import { useEffect, useState } from "react";

interface AppDropDownProps {
  title: string;
  options: string[];
  value?: string;
  required?: boolean;
  onChange?: (option: Record<string, string>) => void;
}
const AppDropDown = ({
  title,
  options,
  onChange,
  value,
  required = false,
}: AppDropDownProps) => {
  const name = title.split(" ").join("_").toLowerCase();
  const [selected, setSelected] = useState<any>(value ?? "");
  useEffect(() => {
    if (options?.length && name && !selected) {
      console.log("updated", name);
      setSelected(options[0]);
      onChange?.({ [name]: options[0] });
    }
  }, [options]);

  return (
    <div className=" flex flex-col gap-1">
      <p className="text-sm capitalize">
        {title}
        {required && " *"}
      </p>
      <div className="flex gap-4 w-full p-3 border border-black rounded-lg ">
        <select
          name={name}
          id={name}
          value={selected}
          className="text-text-grey text-sm pr-8 outline-none w-full bg-transparent"
          onChange={(e) => {
            setSelected(e.target.value);
            onChange && onChange({ [name]: e.target.value });
          }}
        >
          {options.map((option, index) => (
            <option key={index} value={option} className="bg-white">
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default AppDropDown;
